import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DocumentElement } from "../../types/document";

export interface DocumentState {
  documentElements: DocumentElement[];
  loading: boolean;
  error: boolean;
}

export const initialState: DocumentState = {
  documentElements: [],
  loading: false,
  error: false,
};

export const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setDocumentElements: (state, action: PayloadAction<DocumentElement[]>) => {
      state.documentElements = action.payload;
      state.error = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
  },
});

export const { setDocumentElements, setLoading, setError } =
  documentSlice.actions;

export default documentSlice.reducer;
